<template>
    <span class="p-float-label">
        <slot />
    </span>
</template>